var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-container-index" }, [
    _c(
      "div",
      { staticClass: "grid-item-index" },
      [
        _c("analysis-filter", {
          on: {
            loading: function($event) {
              _vm.loading = true
            },
            done: function($event) {
              _vm.loading = false
            }
          },
          model: {
            value: _vm.calls,
            callback: function($$v) {
              _vm.calls = $$v
            },
            expression: "calls"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-item-index" },
      [
        _c("analysis-calls", {
          attrs: { loading: _vm.loading, value: _vm.calls },
          on: {
            processed: function($event) {
              return _vm.processCalls($event)
            },
            loading: function($event) {
              _vm.loading = true
            },
            done: function($event) {
              _vm.loading = false
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-item-index" },
      [_vm.hasControlRead ? _c("analysis-queue", { ref: "queue" }) : _vm._e()],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }